import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BoxLevelEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/box';
import { MenuVerticalVariantEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/menu-vertical';
import { SIDEPANEL_DATA } from '@vueling-ng/vy-ds/src/lib/components/globals/side-panel';
import { SessionOidcService } from 'app/services/external/auth-oidc/session-oidc.service';
import { EnabledSessionsStorageKeys } from 'app/shared/models/configs-sessions-storage';
import { NavigationItems } from 'app/shared/models/navigation-item.model';
import { internalRoutes } from 'environments/common/internal-routes';
import { redirectRoutes_Legacy } from 'environments/common/redirect-routes';
import { environment } from 'environments/environment';
import { take } from 'rxjs';
import {
  AccountManagementData,
  AccountManagementViewModel,
  AccountManagementViewModelEMPTY
} from './models/account-management.model';

@Component({
  selector: 'app-user-info',
  templateUrl: './account-management.component.html',
  styleUrls: ['./account-management.component.scss']
})
export class AccountManagementComponent implements OnInit {
  private readonly _translateService = inject(TranslateService);
  private readonly _sessionOidcService = inject(SessionOidcService);
  private readonly _router = inject(Router);
  private readonly _data = inject<AccountManagementData>(SIDEPANEL_DATA);

  public boxLevel = BoxLevelEnum.LEVEL_TITLE;
  public readonly menuVerticalVariantEnum = MenuVerticalVariantEnum;
  public accountManagementViewModel: AccountManagementViewModel = AccountManagementViewModelEMPTY;

  public ngOnInit(): void {
    this.createStructureByLinks(this._data);
  }

  public closeSession(): void {
    this._sessionOidcService
      .logoff()
      .pipe(take(1))
      .subscribe(() => {
        this.cleanSessionStorage();
        void this._router.navigate([internalRoutes.Auth]);
      });
  }

  private createStructureByLinks(data: AccountManagementData): void {
    const splitUsername = data.userName.split(' ') ?? [];
    this.accountManagementViewModel = {
      userAvatar: {
        title: {
          firstLetter: splitUsername[0] ?? '',
          secondLetter: splitUsername.length === 3 ? splitUsername[1] + ' ' + splitUsername[2] : splitUsername[1]
        }
      },
      userName: data.userName ?? '',
      userEmail: data.email ?? '',
      navigationList: [
        {
          id: NavigationItems.Bookings.title,
          label: NavigationItems.Bookings.title,
          routerLink: internalRoutes.BookingList,
          icon: NavigationItems.Bookings.customIcon
        },
        {
          id: NavigationItems.Invoices.title,
          label: NavigationItems.Invoices.title,
          href: redirectRoutes_Legacy.Invoices,
          icon: NavigationItems.Invoices.customIcon,
          targetBlank: true
        },
        {
          id: NavigationItems.Groups.title,
          label: NavigationItems.Groups.title,
          href: `${environment.groupsBaseUrl}${data.language}/GroupSearch`,
          icon: NavigationItems.Groups.customIcon,
          targetBlank: true
        },
        {
          id: NavigationItems.AgencyCredit.title,
          label: NavigationItems.AgencyCredit.title,
          routerLink: internalRoutes.Bookingscreditflight,
          icon: NavigationItems.AgencyCredit.customIcon
        },
        {
          id: NavigationItems.Cac.title,
          label: NavigationItems.Cac.title,
          href: this._translateService.instant(NavigationItems.Cac.url!) as string,
          icon: NavigationItems.Cac.customIcon,
          targetBlank: true
        },
        {
          id: NavigationItems.AccountManagement.title,
          label: NavigationItems.AccountManagement.title,
          href: `${environment.micewebBaseUrl}${data.language}/Edit`,
          icon: NavigationItems.AccountManagement.customIcon,
          targetBlank: true
        }
      ]
    };
  }

  private cleanSessionStorage(): void {
    sessionStorage.removeItem(EnabledSessionsStorageKeys.state);
  }
}
